import React from 'react';

const Loading = () => {
    return (
       <div className="h-screen flex items-center justify-center">
            <button className="btn btn-square loading"></button>
       </div>
    );
};

export default Loading;